import * as React from 'react'
import { UploadedFileDropdownConnected } from './UploadedFileDropdownConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadedFileDropdownExamples = () => {
  return (
    <div className="UploadedFileDropdownExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadedFileDropdownConnected uploadedFileId="foo" />
      </Provider>
    </div>
  )
}
